import { useCallback, useMemo } from 'react';
import { useHistory } from 'react-router';

import { DEFAULT_LANGUAGE, routes } from '../config/constants';

export const VACANCY_APPLICATION_SLUG = '/vacatures/:vacancy';

const useVacancyApplication = (node) => {
  const history = useHistory();

  const applicationFormPath = useMemo(() => {
    const langcode = node?.langcode?.[0]?.value || DEFAULT_LANGUAGE;

    if (!node?.paths?.[langcode]) {
      return;
    }

    return node.paths[langcode];
  }, [node]);

  const handleApply = useCallback(() => {
    if (!applicationFormPath) {
      return;
    }

    const path = `${routes.jobApplicationForm.replace(VACANCY_APPLICATION_SLUG, applicationFormPath)}`;

    history.push(path, {
      entity: node,
    });
  }, [history, applicationFormPath, node]);

  return {
    handleApply,
  };
};

export default useVacancyApplication;
